import { mergeStyles } from '@cian/utils';
import { plural } from '@cian/utils/lib/shared/plural';
import * as React from 'react';
import { IDeveloper, IDeveloperContact } from '../../../../api/newbuildings';
import DevelopersContactsContainer from '../developers_contacts/container';

import * as styles from './BusinessCard.css';

export interface IBusinessCardProps {
  developer?: IDeveloper | null;
  developerPresenter?: IDeveloperContact;
  isLeadFactory: boolean;
}

export class BusinessCard extends React.PureComponent<IBusinessCardProps> {
  public render() {
    const { developer, developerPresenter, isLeadFactory } = this.props;

    if (!developer) {
      return null;
    }

    if (isLeadFactory) {
      return this.renderCianContacts();
    }

    if (developerPresenter) {
      return this.renderDeveloperPresenter();
    }

    return (
      <div className={styles['wrapper']}>
        <a className={styles['logo']} href={developer.url}>
          {developer.image ? (
            <img className={styles['logo-image']} src={developer.image} alt={`Застройщик ${developer.name}`} />
          ) : (
            <div className={styles['logo-image--placeholder']} />
          )}
        </a>
        <div className={styles['info']}>
          <div className={styles['type']}>Застройщик</div>
          <a className={styles['name']} href={developer.url}>
            {developer.name}
          </a>
          <div className={styles['description']}>{this.getDeveloperOffersDescription()}</div>
          <DevelopersContactsContainer />
        </div>
      </div>
    );
  }

  private getDeveloperOffersDescription = (): string => {
    const { developer } = this.props;

    if (!developer) {
      return '';
    }

    const { offers, newbuildings } = developer;

    if (offers > 0) {
      return `${offers} ${plural(offers, ['квартира', 'квартиры', 'квартир'])} в ${newbuildings} ЖК`;
    } else {
      return `${newbuildings} ЖК в базе ЦИАН`;
    }
  };

  private renderCianContacts = () => {
    return (
      <div {...mergeStyles(styles['wrapper'], styles['wrapper--cian'])}>
        <div className={styles['cian-logo']} />
        <div className={styles['info']}>
          <div className={styles['name']}>Циан</div>
          <div className={styles['subtitle']}>Основан в 2001 году</div>
          <DevelopersContactsContainer />
        </div>
      </div>
    );
  };

  private renderDeveloperPresenter = () => {
    if (!this.props.developerPresenter) {
      return null;
    }
    const { avatarUrl, name } = this.props.developerPresenter;

    return (
      <div className={styles['wrapper']}>
        <div className={styles['logo']}>
          {avatarUrl ? (
            <img className={styles['logo-image']} src={avatarUrl} alt="" />
          ) : (
            <div className={styles['logo-image--placeholder']} />
          )}
        </div>
        <div className={styles['info']}>
          <div className={styles['type']}>Представитель застройщика</div>
          <div className={styles['name']}>{name}</div>
          <DevelopersContactsContainer />
        </div>
      </div>
    );
  };
}
